<template>
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.3292 11.398C13.0363 11.6909 12.5614 11.6909 12.2685 11.398L9.00338 8.13289L5.73827 11.398C5.44538 11.6909 4.9705 11.6909 4.67761 11.398C4.38472 11.1051 4.38472 10.6302 4.67761 10.3373L8.47305 6.54186C8.76595 6.24896 9.24082 6.24896 9.53371 6.54186L13.3292 10.3373C13.6221 10.6302 13.6221 11.1051 13.3292 11.398Z"
      fill="currentColor"
    />
  </svg>
</template>
